import axios from 'axios';
import { logoutUser } from './dataService';

// IMPORTANT: Update this URL to match your backend server address
const API_URL = 'https://apienglish.nguyenluan.vn/api/hangman';

/**
 * A centralized error handler for Hangman API calls.
 */
const handleApiError = (error, defaultMessage) => {
    console.error(`Hangman API Error:`, error.response ? error.response.data : error.message);
    if (error.response && error.response.status === 401) {
        logoutUser(); // This will remove token and reload the page
        throw new Error('Token không hợp lệ hoặc đã hết hạn. Đang đăng xuất...');
    }
    const errorMessage = error.response?.data?.message || error.response?.data?.error || error.message || defaultMessage;
    throw new Error(errorMessage);
};

/**
 * Gets the authorization header with the JWT token.
 */
const getAuthConfig = () => {
    const token = localStorage.getItem('token');
    if (!token) {
        logoutUser();
        throw new Error('Yêu cầu xác thực. Vui lòng đăng nhập lại.');
    }
    return { headers: { Authorization: `Bearer ${token}` } };
};

/**
 * Starts a new Hangman game or multiple games.
 */
const startGame = async (topic = 'common objects', level = 'easy', wordCount = 1) => {
    try {
        const config = getAuthConfig();
        const response = await axios.post(`${API_URL}/start`, { topic, level, wordCount }, config);
        return response.data;
    } catch (error) {
        handleApiError(error, 'Không thể bắt đầu trò chơi mới.');
    }
};

/**
 * Submits a guess for the current game.
 */
const makeGuess = async (gameId, letter) => {
    try {
        const config = getAuthConfig();
        // Send gameId in the body as well to be safe, in case the backend expects it there.
        const response = await axios.post(`${API_URL}/${gameId}/guess`, { gameId, letter }, config);
        return response.data;
    } catch (error) {
        handleApiError(error, 'Gửi lượt đoán không thành công.');
    }
};

/**
 * Gets user's hangman games with optional filtering.
 */
const getUserGames = async (status = null, limit = 10, offset = 0) => {
    try {
        const config = getAuthConfig();
        const params = { limit, offset };
        if (status) params.status = status;

        const response = await axios.get(`${API_URL}/games`, { ...config, params });
        return response.data;
    } catch (error) {
        handleApiError(error, 'Không thể tải danh sách trò chơi.');
    }
};

const hangmanService = {
    startGame,
    makeGuess,
    getUserGames,
};

export default hangmanService;
